import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ContextProductProvider } from "@/Context/Product/ContextProductProvider";
import { ContextTicketCartProvider } from "@/Context/Ticket/ContextTicketCartProvider";
import ScrollToTop from "@/Components/ScrollToTop/ScrollToTop ";
import { lazy, Suspense } from "react";
const Index = lazy(() => import("@/Page/Index"));
const ContextMovilCategorieProvider = lazy(
  () => import("@/Context/Categorie/ContextMovilCategories")
);
const PageTopListCategories = lazy(
  () => import("@/Page/TolListCategories/PageTopListCategories")
);
const SignUp = lazy(() => import("@/Page/SiginUp/SiginUp"));
const PageDetailPdp = lazy(() => import("@/Page/Pdp/PageDetailPdp"));
const PageCheckout = lazy(() => import("@/Page/Checkout/PageCheckout"));
const PageSendBuyCart = lazy(() => import("@/Page/SendBuy/PageSendBuyCart"));

const RouterNavigate = () => {
  return (
    <Suspense>
      <Router
        future={{
          v7_relativeSplatPath: true,
        }}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route
            path="/product/:c"
            element={
              <ContextMovilCategorieProvider>
                <PageTopListCategories />
              </ContextMovilCategorieProvider>
            }
          />
          <Route
            path="/product/:c/:sub/:idSku"
            element={
              <ContextProductProvider>
                <PageDetailPdp />
              </ContextProductProvider>
            }
          />
          <Route
            path="/product/mx/my_puchases/j/a/list"
            element={
              <ContextTicketCartProvider>
                <ContextProductProvider>
                  <PageCheckout />
                </ContextProductProvider>
              </ContextTicketCartProvider>
            }
          />
          <Route
            path="/product/mx/my_checkout/cart/a/checkout"
            element={
              <ContextTicketCartProvider>
                <ContextProductProvider>
                  <PageSendBuyCart />
                </ContextProductProvider>
              </ContextTicketCartProvider>
            }
          />
          <Route path="/c/login" element={<SignUp />} />
        </Routes>
      </Router>
    </Suspense>
  );
};

export default RouterNavigate;
